export const GET_ASSOCIATE_USERS = (
  orgId: string,
  page: number = 1,
  limit: number = 15,
  searchKeyword: string = ''
) => {
  const params = new URLSearchParams();
  params.set('page', page.toString());
  params.set('limit', limit.toString());
  if (searchKeyword) {
    params.set('filter[associate.name]', searchKeyword);
  }
  return (
    `/base/organizations/${orgId}/users/associates?` + `${params.toString()}`
  );
};

export const POST_ASSOCIATE_USERS = (orgId: string) => {
  return `/base/organizations/${orgId}/users/associates`;
};

export const PUT_ASSOCIATE_USERS = (orgId: string, associateId: string) => {
  return `/base/organizations/${orgId}/users/associates/${associateId}`;
};

export const DELETE_ASSOCIATE_USERS = (orgId: string, associateId: string) => {
  return `/base/organizations/${orgId}/users/associates/${associateId}`;
};
